module.exports = __webpack_public_path__ + "static/media/home.60c881f6.png";